"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.zitchaQueries = exports.zitchaQueryKeys = void 0;
const zitcha_api_1 = require("./zitcha.api");
exports.zitchaQueryKeys = {
    all: () => ['zitcha'],
    banners: ({ placement }) => [...exports.zitchaQueryKeys.all(), 'banners', placement],
};
const zitchaQueries = (apiOptions) => ({
    getBanner: (placement) => ({
        queryKey: exports.zitchaQueryKeys.banners(placement),
        queryFn: () => (0, zitcha_api_1.getBanner)(apiOptions, placement),
    }),
});
exports.zitchaQueries = zitchaQueries;
//# sourceMappingURL=zitcha.queries.js.map